import { render, staticRenderFns } from "./faultCode.vue?vue&type=template&id=6bb8d7b0&scoped=true&"
import script from "./faultCode.vue?vue&type=script&lang=js&"
export * from "./faultCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb8d7b0",
  null
  
)

export default component.exports